import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchRepairManagementCall } from '../../api/repairManagement';
import { enqueueSnackbarAction } from '../notifications/actions';
import {
    FETCH_REPAIR_MANAGEMENT,
    requestRepairManagement,
    requestRepairManagementFailure,
    requestRepairManagementSuccess,
} from './actions';

function* fetchRepairManagementSaga(action: AnyAction): SagaIterator {
    yield put(requestRepairManagement());

    const { error, response } = yield call(fetchRepairManagementCall, action.repMgmt);

    if (error) {
        yield put(
            enqueueSnackbarAction({
                message: 'Fehler: Reparaturen konnten nicht geladen werden!\n' + error.message,
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'error',
                },
            })
        );
        yield put(requestRepairManagementFailure(error));
    } else {
        yield put(
            enqueueSnackbarAction({
                message: response.statusText || 'Reparaturen erfolgreich geladen',
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'success',
                },
            })
        );
        yield put(requestRepairManagementSuccess(response));
    }
}

export function* generateFetchRepairManagement() {
    yield takeLatest(FETCH_REPAIR_MANAGEMENT, fetchRepairManagementSaga);
}
